import { QueryParamConfig } from 'use-query-params';

const paramsToObject = (entries: IterableIterator<[string, string]>) => {
  const result: { [key: string]: string } = {};
  for (const entry of entries) {
    const [key, value] = entry;
    result[key] = value;
  }
  return result;
};

export const searchStringToParamsObject = (search: string) =>
  paramsToObject(new URLSearchParams(search).entries());

export const JsonObjectParam: QueryParamConfig<
  Record<string, unknown> | null | undefined,
  Record<string, unknown> | undefined
> = {
  encode: value =>
    value && Object.keys(value).length > 0 ? JSON.stringify(value) : undefined,
  decode: value => {
    const encodedValue = Array.isArray(value) ? value[0] : value;
    if (!encodedValue) return undefined;

    try {
      const decodedValue: unknown = JSON.parse(encodedValue);
      return decodedValue &&
        typeof decodedValue === 'object' &&
        !Array.isArray(decodedValue)
        ? (decodedValue as Record<string, unknown>)
        : undefined;
    } catch {
      return undefined;
    }
  },
};
